import clsx from 'clsx'
import React, {memo} from 'react'

import {ChevronIcon} from '../icons'
import * as classes from './classes'
import {useAccordion} from './hooks'
import {SummaryProps} from './types'

const AccordionSummary = memo<SummaryProps>(({'data-testid': dataTestId, children, className, lead}) => {
  const {isExpanded, toggle} = useAccordion()

  return (
    <header className={clsx(classes.summaryRoot, className)} data-testid={dataTestId}>
      <div className={classes.summaryLead}>{lead}</div>
      <div>{children}</div>
      <nav className={classes.summaryNavigation}>
        <button className={classes.summaryNavigationButton} onPointerUp={toggle} type="button">
          <ChevronIcon className={clsx(classes.summaryTrailIcon, {[classes.summaryExpandedTrailIcon]: isExpanded})} />
        </button>
      </nav>
    </header>
  )
})

AccordionSummary.displayName = 'AccordionSummary'

export {AccordionSummary}
